import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { DEFAULT_DEBOUNCE_RATE } from '../../Base.constants';
import { useFiltersContext } from '../../components/Filters';
import { Filters } from '../../models';

interface useFeedFiltersResult {
  filters: Filters | null;
}

const useFeedFilters = (): useFeedFiltersResult => {
  const { filters: filtersContext } = useFiltersContext();

  const [filters, setFilters] = useState<Filters | null>(filtersContext);
  const setDebouncedFilters = useDebouncedCallback((filters: Filters | null) => {
    setFilters(filters);
  }, DEFAULT_DEBOUNCE_RATE);

  useEffect(() => {
    setFilters(filtersContext);
  }, []);

  useEffect(() => {
    setDebouncedFilters(filtersContext);
  }, [filtersContext]);

  return { filters };
};

export default useFeedFilters;
